module.exports = __webpack_public_path__ + "static/img/badge.ce2b4d2c.png";